module.exports = __webpack_public_path__ + "img/pledgeQuantity.e304066b.png";